import React from "react";

import { HStack, Switch, Text } from "@chakra-ui/react";

export const BoxModeToggle = ({ is3DMode, onToggle }) => {
    return (
        <HStack mr={4}>
            <Text>2D</Text>
            <Switch
                size="lg"
                w="-moz-fit-content"
                isChecked={is3DMode}
                onChange={(e) => onToggle && onToggle(e.target.checked)}
                aria-label="Toggle 3D preview"
            />
            <Text>3D</Text>
        </HStack>
    );
};
